module.exports = __webpack_public_path__ + "img/709.e3774140.png";